import script from "./XFPaintView.vue?vue&type=script&setup=true&lang=js"
export * from "./XFPaintView.vue?vue&type=script&setup=true&lang=js"

import "./XFPaintView.vue?vue&type=style&index=0&id=3f010003&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f010003"]])

export default __exports__